import { Outlet } from 'react-router-dom';

export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 mx-auto w-full max-w-screen-sm px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
